export default "__VITE_ASSET__DqkspfI$__"